import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { config } from '../Config/config'
import DetailDoctorService from '../Service/DetailDoctorService'
import PasienService from '../Service/pasienService'
import AppointmentService from '../Service/appointmentService'
import FormInput from './formInput'
import Modal from './modal'
import ModalBerhasilSimpan from './modalBerhasilSimpan'
import './detaildoctor.css'
import './appointment.css'
import Login from '../Login/login'
import Register from '../Login/register'
import ForgotPass from '../Login/forgotpassword'
import appointmentService from '../Service/appointmentService'
// import FormInputJanji from './formInput'
// import FormInputJanjiNew from '../rencana_kedatangan/formInputNew'
import ModalLoading from './modalLoading'
import ModalPenuh from './modalPenuh'
import ModalTidakAdaDokter from './modalTidakAdaDokter'
import ModalTidakAdaDokterSalahJam from './modalTidakAdaDokterSalahJam'
import ModalPasien from './modalPasien'




export default class DetailDoctor extends React.Component {
    AppointmentModel = {
        // _id: "",
        customer_id: "",
        doctor_office_id: "",
        doctor_office_schedule_id: "",
        doctor_office_treatment_id: "",
        appointment_date: "",
        is_delete: false,
        biodata_id: localStorage.getItem(config.biodata_id),
        doctor_id: localStorage.getItem(config.cariIdDoctor),
        medical_facility_id: "",
        created_by: localStorage.getItem(config.userid),
        created_on: "",

        tanggal_datang: "",
        tanggal_datang2: "",
        day: "",
        faskes: "",
        // nama_dokter: "",
        jam: "",
        name: {},
        tanggal: "",
        tahunP: "",
        bulanP: "",
        tanggalP: "",
        tahunApp: "",

        tahunCek: "",
        bulanCek: "",
        tanggalCek: "",


        // medical_facility_id:"",
        // doctor_id:"606440dd2cec8b3624e95b2d",

    }

    constructor() {
        super()
        this.state = {
            textJadwal: "Lihat",
            icon: "fa fa-caret-down",
            ketHist: "Sekarang",

            data: {
                // id_doctor: "606440dd2cec8b3624e95b2c",
                id_doctor: localStorage.getItem(config.cariIdDoctor),
                // parent_biodata_id : "6071b0dcf6bd526f18e78252",
            },

            bioList: [],
            schList: [],
            schList2: [],
            isOnline: "",
            dispOn: "none",
            dispOff: "none",
            treatList: [],
            listTreatment: [],
            eduList: [],
            histList: [],
            locList: [],
            faskesList: [],
            faskesDetailList: [],
            faskesListA: [],
            faskes: "",
            relasiList: [],
            janjiList: [],

            Model: this.AppointmentModel,
            Model2: this.AppointmentModel,
            List: [],
            ListCostumer_Relation: [],
            Mode: "",
            ShowModalJanji: false,
            ShowModal: false,
            ShowModal1: false,
            ShowModalreg: false,
            ShowModalforgot: false,
            errors: {},
            disabled: true,
            // ShowModalJanjiNew: false,
            tanggal: "",
            tanggal_datang2: "",
            jam: "",
            cek: [],
            showModalLoad: false,
            showModalPenuh: false,
            showModalNoDokter: false,
            ShowModalBerhasilSimpan: false,
            showModalNoDokterSalahJam: false,
            idOffice: "",
            coba: [],
            coba2: [],
            d: new Date(),

            jamApp: "",
            menitApp: "",
            dateApp: "",
            monthApp: "",
            yearApp: "",
            jamNow: "",
            menitNow: "",
            dateNow: "",
            monthNow: "",
            yearNow: "",
            name: {},
            formIsValid: true,


        }
    }

    loadList = async () => {

        const responBio = await DetailDoctorService.getBiodata(this.state.data)
        if (responBio.success) {
            this.setState({
                bioList: responBio.result,
            })
            {
                this.state.bioList.map(data => {
                    this.setState({
                        image: data.image
                    })
                })
            }
        }

        const responTreat = await DetailDoctorService.getTreatment(this.state.data)
        if (responTreat.success) {
            this.setState({
                treatList: responTreat.result,
            })
        }

        const responEdu = await DetailDoctorService.getEducation(this.state.data)
        if (responEdu.success) {
            this.setState({
                eduList: responEdu.result,
            })
        }

        const responHist = await DetailDoctorService.getHistory(this.state.data)
        if (responHist.success) {
            this.setState({
                histList: responHist.result,
            })
            {
                this.state.histList.map(data => {
                    this.setState({
                        faskesListA: this.state.faskesListA.concat([data.faskesList])
                        // locParent: this.state.locParent.concat([data.locParent])
                    })
                })
            }
        }

        const responLoc = await DetailDoctorService.getLokasi(this.state.data)
        if (responHist.success) {
            this.setState({
                locList: responLoc.result,

            })
            {
                this.state.locList.map(data => {
                    this.setState({
                        price: data.price,
                        // faskesListA: this.state.faskesListA.concat([data.namaRS]),
                        // Model: {
                        //     ...this.state.Model,
                        //     doctor_office_id: data.office_id,
                        // },
                    })
                })
            }
        }
        const resSchedule = await DetailDoctorService.getJadwal(this.state.data)
        if (resSchedule.success) {
            this.setState({
                schList: resSchedule.result
            })
        }
        console.log(this.state.schList)

        // const resRelasi = await AppointmentService.getAllDataJanji({"biodata_id": this.AppointmentModel.biodata_id})
        // if (resRelasi.success) {
        const resSchedule2 = await DetailDoctorService.getValidJadwal(this.state.data)
        if (resSchedule2.success) {
            this.setState({
                schList2: resSchedule2.result
            })
        }
        // console.log(this.state.schList2)
        {
            this.state.schList2.map(data => {
                if (data.validHari == true && data.validJam == true) {
                    this.setState({
                        isOnline: "Online",
                    })
                }
            })
        }
        if (this.state.isOnline == "Online") {
            this.setState({
                dispOff: "none",
                dispOn: ""
            })
        } else {
            this.setState({
                isOnline: "Offline",
                dispOff: "",
                dispOn: "none"
            })
        }

        const resRelasi = await AppointmentService.getAllDataJanji({ "biodata_id": this.AppointmentModel.biodata_id })
        if (resRelasi.success) {
            this.setState({
                relasiList: resRelasi.result
            })
        }

        const resJanjiJanji = await AppointmentService.getAllDataJanji({ "biodata_id": this.AppointmentModel.biodata_id })
        if (resJanjiJanji.success) {
            this.setState({
                janjiList: resJanjiJanji.result
            })
        }

        const resFaskes = await AppointmentService.getFaskes({ "doctor_id": this.AppointmentModel.doctor_id })
        console.log(resFaskes.result)
        if (resFaskes.success) {
            this.setState({
                faskesList: resFaskes.result
            })
        }

        const resFaskesDetail = await AppointmentService.getFaskesDetail({ "doctor_id": this.AppointmentModel.doctor_id })
        console.log(resFaskesDetail.result)
        if (resFaskesDetail.success) {
            this.setState({
                faskesDetailList: resFaskesDetail.result
            })
        }

        // const responListTreat = await AppointmentService.getTreatmentByDoctorOfficeId(this.state.Model.doctor_office_id)
        // if (responListTreat.success) {
        //     this.setState({
        //         listTreatment: responListTreat.result,
        //     })
        // }
    }

    componentDidMount() {
        this.loadList()
    }

    expandHandler = () => {
        const { textJadwal, icon } = this.state
        if (textJadwal == "Lihat") {
            this.setState({
                textJadwal: "Sembunyikan",
                icon: "fa fa-caret-up"
            })
        } else {
            this.setState({
                textJadwal: "Lihat",
                icon: "fa fa-caret-down"
            })
        }
    }
    chatHandler = () => {
        this.setState({
            ShowModal1: true
        })
    }

    saveHandler = async () => {
        console.log(this.state.Mode)
        if (this.state.Mode == "Buat Janji") {

            if (this.handleValidation()) {
                var d = new Date(this.state.Model.appointment_date)
                var d1 = d.getDay().toString()
                this.setState({
                    showModalLoad: true,
                    tanggal: this.state.Model.appointment_date.substring(0, 10),
                    jam: parseInt(this.state.Model.appointment_date.substring(11, 13)),
                    Model: {
                        ...this.state.Model,
                        jam: parseInt(this.state.Model.appointment_date.substring(11, 13)),
                        day: d.getDay().toString(),
                        tanggal: this.state.Model.appointment_date.substring(0, 10),
                        tahunP: parseInt(this.state.Model.appointment_date.substring(0, 4)),
                        bulanP: parseInt(this.state.Model.appointment_date.substr(5, 2)),
                        tanggalP: parseInt(this.state.Model.appointment_date.substr(8, 2)),
                    }
                })
                console.log(this.state.Model.appointment_date)
                console.log(this.state.Model)


                //cek hari dan jam
                var responDay = await appointmentService.cekDayAppointment(
                    {
                        // "faskes": this.state.Model.medical_facility,
                        // "nama_dokter": this.state.Model.nama_dokter,
                        // "day": d1,
                        "day": d.getDay().toString(),
                        "jam": parseInt(this.state.Model.appointment_date.substring(11, 13)),
                        // "jam": this.state.Model.jam,
                        "doctor_id": this.state.Model.doctor_id,
                        // "doctor_office_id": this.state.Model.doctor_office_id,
                        "doctor_office_id": this.state.idOffice,
                        "doctor_office_schedule_id": this.state.Model.doctor_office_schedule_id,
                        "appointment_date": this.state.Model.appointment_date,
                    })
                console.log(this.state.Model)
                console.log(this.state.Model.jam)
                console.log(this.state.Model.day)
                console.log(responDay.result)

                // console.log(responDay.result[0].slot)
                // console.log(responDay.result[0].jam_end)
                // console.log(responDay.result[0].jam_start)
                // console.log(responDay.result.jam)

                // if (responDay.result.jam > responDay.result[0].jam_end) {
                //     alert("salah pilih jam")
                // }

                //jika hari dan jam sesuai jadwal dokter
                if (responDay.result.length != 0) {
                    console.log(responDay.result[0].slot)
                    console.log(responDay.result[0].jam_end)
                    console.log(responDay.result[0].jam_start)
                    this.setState({
                        slot: parseInt(responDay.result[0].slot),
                        Model: {
                            ...this.state.Model,
                            doctor_office_schedule_id: responDay.result[0].doctor_office_schedule_id,
                            jam: responDay.result.jam,

                        }
                    })
                    const responCek = await appointmentService.cekRencanaAppoinment(this.state.tanggal)
                    this.setState({
                        cek: responCek.result,
                    })
                    console.log(this.state.cek)
                    console.log(this.state.Model)
                    console.log(this.state.slot)
                    // console.log(this.state.cek.length)
                    console.log(this.state.slot)


                    console.log(this.state.Model)
                    const respons = await appointmentService.cekPasienByJanji(this.state.Model)
                    this.state.formIsValid = this.handleValidation.formIsValid;

                    // var name = {}
                    if (respons.success) {
                        // name = respons.result
                        this.setState({
                            name: respons.result
                        })
                        if (this.state.name != undefined) {
                            this.setState({
                                formIsValid: false
                            })
                            alert("* Pasien sudah ada.")
                        }
                        else {
                            // this.state.formIsValid = true
                            this.setState({
                                formIsValid: true
                            })
                        }
                    }
                    console.log(this.state.name)


                    console.log(this.state.formIsValid)
                    // if (this.state.cek.length < this.state.slot && this.state.formIsValid == true) {
                    if (this.state.cek.length < this.state.slot) {
                        if (this.state.formIsValid == true) {
                            const respond = await AppointmentService.addDataJanji({
                                "_id": this.state.Model._id,
                                "doctor_office_schedule_id": this.state.Model.doctor_office_schedule_id,
                                "doctor_office_treatment_id": this.state.Model.doctor_office_treatment_id,
                                "appointment_date": this.state.Model.appointment_date,
                                "created_by": this.state.Model.created_by,
                                "customer_id": this.state.Model.customer_id,
                                // "doctor_office_id": this.state.Model.doctor_office_id,
                                "doctor_office_id": this.state.idOffice,
                                // "day": d1,
                                // "jam": this.state.jam,
                                "day": d.getDay().toString(),
                                "jam": parseInt(this.state.Model.appointment_date.substring(11, 13)),

                            })
                            console.log(respond)
                            console.log(this.state.cek.length)
                            console.log(this.state.slot)

                            this.setState({
                                Model2: respond.result,
                                jam: parseInt(this.state.Model.tanggal_datang.substring(11, 13)),
                                tanggal_datang2: this.state.Model.tanggal_datang.concat('Z'),

                            })
                            console.log(d1)
                            console.log(this.state.jam)
                            console.log(this.state.tanggal)
                            console.log(this.state.tanggal_datang2)

                            if (respond.success) {
                                // alert("Succes Save Data")
                                this.setState({
                                    // Model: this.AppointmentModel,
                                    ShowModalBerhasilSimpan: true,
                                    ShowModalJanji: false,
                                    showModalLoad: false,
                                    showModalPenuh: false,
                                    disabled: true,
                                }, () => { console.log(this.state.Model) })

                                this.loadList()
                                // alert("Success Update Data")
                            }
                            else {
                                alert("nama sudah ada")
                            }

                        } else {
                            this.setState({
                                showModal: false,
                                showModalLoad: false,
                                showModalPenuh: false,
                                showModalPasien: true
                            })
                        }
                    }

                    else {
                        this.setState({
                            showModal: false,
                            showModalLoad: false,
                            showModalPenuh: true,
                            // showModalPasien: false
                        })
                        // }
                    }

                }
                // else                 
                if (responDay.result.length == 0) {
                    {
                        this.state.schList.map(list => {
                            console.log(list.id)
                            this.state.coba2.push(list)
                        })
                    }
                    // this.state.coba2.forEach((element, index) => {
                    //     console.log(element)
                    // })
                    let cekIdOffice = false
                    this.state.coba2.forEach((element, index) => {
                        if (this.state.idOffice == element.id_office) {
                            cekIdOffice = true
                        }



                    })
                    if (cekIdOffice == true) {
                        // this.state.coba2.push(list)
                        let cekHari = false
                        this.state.coba2.forEach((element, index) => {
                            console.log(element)
                            if (this.state.Model.day == element.hari2) {
                                cekHari = true
                            }
                        })

                        if (cekHari == true) {
                            let idTrue = true
                            this.state.coba2.forEach((element, index) => {

                                if (this.state.Model.jam < element.jam_mulai || this.state.Model.jam > element.jam_akhir) {
                                    idTrue = false
                                }
                            })
                            if (idTrue == false) {
                                alert("jam salah")
                                this.setState({
                                    showModalLoad: false,
                                    showModalNoDokter: false,
                                    showModalNoDokterSalahJam: true,
                                })
                            }
                        }
                        else {
                            alert("salah hari")
                            this.setState({
                                showModalLoad: false,
                                showModalNoDokter: true,
                            })
                        }

                        // if (this.state.Model.day != list.hari2) {
                        //     alert("salah hari")
                        // this.setState({
                        //     showModalLoad: false,
                        //     showModalNoDokter: true,
                        // })
                        // }

                        // if (this.state.Model.day == list.hari2) {
                        //     // else {
                        //     if (this.state.Model.jam < list.jam_mulai || this.state.Model.jam > list.jam_akhir) {
                        //         this.state.coba.push(list)

                        //         alert("jam salah")
                        //         this.setState({
                        //             showModalLoad: false,
                        //             showModalNoDokter: false,
                        //             showModalNoDokterSalahJam: true,
                        //         })
                        //     }
                        // }

                    }
                    console.log(this.state.coba2)
                    console.log(this.state.coba)



                    // for (let i = 0; i < this.state.schList.length; i++) {
                    //     if ((this.state.idOffice) == this.state.schList[i].id_office) {
                    //         console.log(this.state.Model.day)
                    //         console.log(this.state.schList[i].hari2)
                    //         console.log(this.state.schList[0].hari2)
                    //         console.log(this.state.schList[1].hari2)
                    //         if ((this.state.Model.day) == this.state.schList[i].hari2) {
                    //             // if ((this.state.Model.jam) < this.state.schList[i].jam_mulai) {
                    // this.setState({
                    //     showModalLoad: false,
                    //     showModalNoDokter: false,
                    //     showModalNoDokterSalahJam: true,

                    // })
                    //             // alert("Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut")
                    //             // alert("hari benar, salah pilih jam")
                    //             // }
                    //         } else {
                    //             this.setState({
                    //                 showModalLoad: false,
                    //                 showModalNoDokterSalahJam: false,
                    //                 showModalNoDokter: true,
                    //                 // alert("Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut")

                    //             })
                    //         }
                    //     }

                    // }

                    // this.setState({
                    //     showModalLoad: false,
                    //     showModalNoDokter: true,
                    //     // alert("Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut")
                    // })

                }

                // else {
                //     this.setState({
                //         showModalLoad: false,
                //         showModalNoDokter: true,
                //         // alert("Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut")
                //     })
                // }
                // }
            }
            // else {
            //     alert('Form has errors.')
            // }
        } else {
            alert('Form has errors.')
        }
    }

    handleValidation() {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;

        //get month and year NOW        
        var year = this.state.d.getFullYear()
        var yearStr = year.toString().substring(0, 4)
        var yearNow = parseInt(yearStr)
        var monthStr = this.state.d.getMonth().toString().substring(0, 2)
        var monthNow = parseInt(monthStr) + 1
        var dateNow = this.state.d.getDate().toString()
        var jamNow = parseInt(this.state.d.getHours().toString())
        var menitNow = parseInt(this.state.d.toString().substr(19, 2))



        //get month and year appoinment
        var day = new Date(this.state.Model.appointment_date)
        var yearApp = parseInt(this.state.Model.appointment_date.substring(0, 4))
        var monthApp = parseInt(this.state.Model.appointment_date.substr(5, 2))
        var dateApp = this.state.Model.appointment_date.substr(8, 2)
        var jamApp = parseInt(this.state.Model.appointment_date.substring(11, 13))
        var menitApp = parseInt(this.state.Model.appointment_date.substring(14, 16))

        console.log(this.state.d), console.log(this.state.d.getDate()), console.log(this.state.d.getHours())
        console.log(yearNow)
        console.log(monthNow)
        console.log(dateNow)
        console.log(jamNow)
        console.log(menitNow)

        console.log(this.state.Model.appointment_date)
        console.log(yearApp)
        console.log(monthApp)
        console.log(dateApp)
        console.log(jamApp)
        console.log(menitApp)

        //Customer
        if (!fields["customer_id"]) {
            formIsValid = false;
            errors["customer"] = "* Pasien harus diisi."
        }
        // if (this.state.name != undefined) {
        //     formIsValid = false;
        //     errors["customer"] = "* Pasien sudah ada."
        // }

        //tanggal_janji
        // if (!fields["tanggal_datang"]) {
        if (!fields["appointment_date"]) {
            formIsValid = false;
            // errors["tanggal_janji"] = "* Tanggal dan Jam harus diisi."
            errors["tanggal_janji_expired"] = "* Tanggal dan Jam harus diisi."
        } else if (fields["appointment_date"] != undefined) {
            if (yearNow == yearApp) {
                if (monthApp < monthNow) {
                    formIsValid = false;
                    errors["tanggal_janji_expired"] = "* Tanggal tidak valid."
                }
                else if (monthApp == monthNow) {
                    if (dateApp < dateNow) {
                        formIsValid = false;
                        errors["tanggal_janji_expired"] = "* Tanggal tidak valid."
                    }
                    else if (dateApp == dateNow) {
                        if (jamApp < jamNow) {
                            formIsValid = false;
                            errors["tanggal_janji_expired"] = "* Tanggal dan Jam tidak valid."
                        }
                        else if (jamApp == jamNow) {
                            if (menitApp < menitNow) {
                                formIsValid = false;
                                errors["tanggal_janji_expired"] = "* Tanggal dan Jam tidak valid."
                            }
                        }
                    }
                }

            }
            else if (yearApp < yearNow) {
                formIsValid = false
                errors["tanggal_janji_expired"] = "* Tanggal tidak valid."
            }
        }

        //tindakan
        if (!fields["doctor_office_treatment_id"]) {
            formIsValid = false;
            errors["tindakan"] = "* Tindakan harus diisi."
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    faskesHandler = async () => {
        const { idOffice } = this.state
        console.log(idOffice)
        // alert("faskeshandler")

        const responListTreat = await AppointmentService.getTreatmentByDoctorOfficeId(idOffice)
        // const responListTreat = await AppointmentService.getTreatmentByDoctorOfficeId(this.state.Model.doctor_office_id)
        if (responListTreat.success) {
            this.setState({
                listTreatment: responListTreat.result,
            })
        }
    }

    // janjiHandler = (data) => {

    //     this.setState({
    //         // faskes: data.namaRS,
    //         Model: {
    //             ...this.state.Model,
    //             doctor_office_id: data.office_id
    //         },
    //     },
    //         // () => this.loadList())
    //         // () => this.faskesHandler())    
    //         console.log(this.state.Model.doctor_office_id))
    //     // console.log(this.state.Model.namaRS)
    //     if (!localStorage.getItem(config.token)) {
    //         this.setState({
    //             ShowModal: true
    //         })
    //     } else {
    //         this.setState({
    //             Mode: "Buat Janji",
    //             Model: this.AppointmentModel,
    //             // faskes: this.state.Model.namaRS,
    //             ShowModalJanji: true,
    //             showModalNoDokter: false,
    //             showModalPenuh: false,
    //             // ShowModalJanjiNew: true,
    //         })
    //     }
    //     // console.log(this.state.Model.doctor_office_id)
    // }

    janjiHandler2 = (id) => {
        console.log(id)


        this.setState({
            idOffice: id
        })
        // () => {localStorage.setItem(config.cariIdOfficeDoctor, this.state.idOffice)})
        // () => console.log(this.state.idOffice))
        // () => this.faskesHandler())    
        // console.log(localStorage.getItem(config.cariIdOfficeDoctor))
        // console.log(this.state.Model.namaRS)
        if (!localStorage.getItem(config.token)) {
            this.setState({
                ShowModal: true
            })
        } else {
            this.setState({
                Mode: "Buat Janji",
                Model: this.AppointmentModel,
                // faskes: this.state.Model.namaRS,
                ShowModalJanji: true,
                showModalNoDokter: false,
                showModalNoDokterSalahJam: false,
                showModalPenuh: false,
                showModalPasien: false,

            })
        }
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            },
            disabled: false,
        },
            () => this.faskesHandler()
        )
        // console.log(this.state.Model.location_level_id)
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModalJanji: false,
            ShowModalBerhasilSimpan: false,
            ShowModal: false,
            ShowModal1: false,
            errors: {},
            showModalLoad: false,
            showModalPenuh: false,
            showModalNoDokter: false,
            showModalNoDokterSalahJam: false,
            disabled: true,
            showModalPasien: false,
        })
    }


    cancelRegHandler = () => {
        this.setState({
            ShowModalreg: false
        })
    }

    cancelforgotHandler = () => {
        this.setState({
            ShowModalforgot: false
        })
    }

    ModalHandler = () => {
        this.setState({
            ShowModal: true,
            ShowModalreg: false,
            ShowModalforgot: false
        })
    }

    ModalRegHandler = () => {
        this.setState({
            ShowModalreg: true,
            ShowModal: false,
            ShowModalforgot: false
        })
    }

    ModalLupassHandler = () => {
        this.setState({
            ShowModalforgot: true,
            ShowModalreg: false,
            ShowModal: false

        })
    }
    render() {
        const { textJadwal, icon, treatList, eduList, histList, janjiList,
            locList, bioList, schList, ShowModalreg, ShowModalforgot, ShowModal, listTreatment, idOffice } = this.state
        const { List, faskesList, relasiList, Model, ShowModalJanji, ShowModalJanjiNew, ShowModalBerhasilSimpan, errors, Mode, disabled } = this.state
        return (
            <div class="card-box profile-header">
                {/* {JSON.stringify(Model)}
                {JSON.stringify(listTreatment)} */}

                {/* {JSON.stringify(this.state.Model)} */}
                {/* {JSON.stringify(this.state.faskes)} */}
                {/* {JSON.stringify(this.state.test)} */}
                {/* {JSON.stringify(Model)} */}
                {/* {JSON.stringify(this.state.schList2)} */}

                <div class="row">
                    <div class="col-md-12">
                        <div class="profile-view" style={{ margin: 30 }}>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="profile-img">
                                        <a href="#"><img class="avatar" src={this.state.image} alt="" /></a>
                                    </div>
                                </div>

                                <div class="col-md-6" style={{ paddingTop: 30 }}>
                                    <div class="profile-info-left">
                                        <div class="row padding-top : 20px" style={{ marginLeft: 30 }}>
                                            <div class="col-md-9">
                                                {bioList.map(data => {
                                                    return (
                                                        <tbody>
                                                            <h3 class="text">{data.fullname}</h3>
                                                            <small class="text">{data.sp}</small>
                                                            <div class="text">{parseInt(data.Tyear) - parseInt(data.Lyear)} tahun pengalaman</div>
                                                        </tbody>
                                                    )
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3" style={{ padding: 40 }}>
                                    <div class="float-right" style={{ display: this.state.dispOn }}>
                                        <button class="btn btn-block btn-primary btn-lg" onClick={this.chatHandler}>Chat Dokter</button>
                                        <div class="" style={{ marginLeft: 27 }}>
                                            <small class="text">Rp. {this.state.price}</small>
                                        </div>
                                    </div>
                                    <div class="float-right" style={{ display: this.state.dispOff }}>
                                        <button class="btn btn-secondary btn-lg disabled">{this.state.isOnline}</button>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-3">
                                    <div>
                                        <h4 class="text-primary">Tindakan Medis</h4>
                                        <p class="profile-info" style={{ padding: 10 }}>
                                            <div class="text">
                                                {treatList.map(data => {
                                                    return (
                                                        <h5>- {data.name}</h5>
                                                    )
                                                })}
                                            </div>
                                        </p>

                                        <h4 class="text-primary">Riwayat Praktek</h4>
                                        <p class="profile-info" style={{ padding: 10 }}>
                                            <div class="text">
                                                {histList.map(data => {
                                                    return (
                                                        <tbody>
                                                            <tr>
                                                                <td><h5>{data.namaRS}, {data.parent} </h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td><h6 style={{ marginLeft: 10 }}>{data.spesialis}</h6></td>

                                                                <td style={{ textAlign: 'right' }}><h6>{data.tCreate}-{data.ket}</h6></td>
                                                            </tr>
                                                        </tbody>
                                                    )
                                                })}
                                            </div>
                                        </p>

                                        <h4 class="text-primary">Pendidikan</h4>
                                        <p class="profile-info" style={{ paddingTop: 20, paddingBottom: 10 }}>
                                            <div class="text">
                                                {eduList.map(data => {
                                                    return (
                                                        <tbody>
                                                            <tr>
                                                                <td class="col-md-12"><h5>{data.institution_name}</h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td class="col=md-6"><h6 style={{ marginLeft: 20 }}>{data.major}</h6></td>
                                                                <td class="col-md-6"><h6>{data.end_year}</h6></td>
                                                            </tr>
                                                        </tbody>
                                                    )
                                                })}
                                            </div>
                                        </p>
                                    </div>
                                </div>

                                <div class="col-md-9">
                                    <div class="profile-info-left">
                                        <div class="row padding-top : 20px" style={{ marginLeft: 30 }}>
                                            <div class="container" style={{ paddingRight: 40 }}>
                                                <h4 class="text-primary">Lokasi Praktek</h4>

                                                {locList.map(data => {

                                                    return (
                                                        <div class="profile-info container col-md-12" style={{ marginBottom: 30, padding: 10 }}>
                                                            <div class="row">
                                                                <div class="col-9">
                                                                    <h5 style={{ paddingLeft: 10 }}>{data.namaRS}</h5>
                                                                    <h6 style={{ paddingLeft: 15 }}>{data.category}</h6>
                                                                    {/* <h6 style={{ paddingLeft: 15 }}>{data.office_id}</h6> */}
                                                                    <h6 style={{ paddingLeft: 15 }}>
                                                                        <i class="fa fa-map-marker"></i> {data.fAddress}, {data.lokasi}, {data.parent}</h6>
                                                                </div>
                                                                <div class="col-3 text-primary" style={{ textAlign: 'center', marginTop: 10, color: 'blue' }}>
                                                                    <h6>Konsultasi mulai dari</h6>
                                                                    <h6>Rp. {data.start}</h6>
                                                                </div>
                                                            </div>

                                                            <p class="profile-text" style={{ padding: 0, marginBottom: 0 }}>
                                                                <button class="btn btn-link" type="button" data-toggle="collapse" data-target={`#collapse${data.rs_id}`} aria-expanded="false" aria-controls="collapseExample" onClick={() => this.expandHandler(data.rs_id)}>
                                                                    <i class={icon}></i> { } jadwal Praktek
                                                                </button>
                                                                <div class="collapse" id={`collapse${data.rs_id}`}>
                                                                    <div class="row">
                                                                        <div class="col-9">
                                                                            {schList.map(data2 => {
                                                                                if (data.namaRS == data2._id) {
                                                                                    return (
                                                                                        <div class="row">
                                                                                            <div class="col-2">
                                                                                                <h6 style={{ marginLeft: 25 }}>{data2.hari}</h6>
                                                                                            </div>
                                                                                            <div class="col-3">
                                                                                                <h6 style={{ marginLeft: 25 }}>{data2.mulai} - {data2.akhir}</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                            })}
                                                                        </div>
                                                                        <div class="col-3">
                                                                            <button class="btn btn-block btn-primary btn-lg" onClick={() => this.janjiHandler2(data.office_id)} >Buat Janji</button>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </p>

                                                        </div>
                                                    )

                                                })}

                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <FormInput
                            ShowModalJanji={ShowModalJanji}
                            // ShowModalBerhasilSimpan={ShowModalBerhasilSimpan}
                            List={this.state.List}
                            ListCostumer_Relation={this.state.ListCostumer_Relation}
                            bioList={this.state.bioList}
                            treatList={this.state.treatList}
                            listTreatment={this.state.listTreatment}
                            locList={this.state.locList}
                            faskesList={this.state.faskesList}
                            relasiList={this.state.relasiList}
                            janjiList={this.state.janjiList}
                            faskes={this.state.faskes}
                            Model={Model}
                            janjiHandler={this.janjiHandler}
                            janjiHandler2={this.janjiHandler2}
                            saveHandler={this.saveHandler}
                            changeHandler={this.changeHandler}
                            cancelHandler={this.cancelHandler}
                            errors={errors}
                            Mode={Mode}
                            image={this.state.image}
                            disabled={disabled}
                            idOffice={idOffice}

                        />
                        <Modal
                            ShowModal1={this.state.ShowModal1}
                            cancelHandler={this.cancelHandler}

                        />
                        <ModalBerhasilSimpan
                            ShowModalBerhasilSimpan={this.state.ShowModalBerhasilSimpan}
                            cancelHandler={this.cancelHandler}
                            List={List}
                            Model={this.state.Model}
                            errors={errors}
                        />
                        <Login
                            ShowModal={ShowModal}
                            cancelHandler={this.cancelHandler}
                            ModalRegHandler={this.ModalRegHandler}
                            ModalLupassHandler={this.ModalLupassHandler} />
                        <Register
                            ShowModalreg={ShowModalreg}
                            cancelRegHandler={this.cancelRegHandler}
                            ModalHandler={this.ModalHandler}
                        />
                        <ForgotPass
                            ShowModalforgot={ShowModalforgot}
                            cancelforgotHandler={this.cancelforgotHandler}
                            ModalHandler={this.ModalHandler}
                        />

                        <ModalLoading
                            showModalLoad={this.state.showModalLoad}
                            cancelHandler={this.cancelHandler}
                            List={List}
                            Model={this.state.Model}
                            errors={errors}
                        />
                        <ModalPenuh
                            showModalPenuh={this.state.showModalPenuh}
                            cancelHandler={this.cancelHandler}
                            List={List}
                            Model={this.state.Model}
                            Model2={this.state.Model2}
                            errors={errors}
                            janjiHandler={this.janjiHandler}
                            janjiHandler2={this.janjiHandler2}
                            idOffice={idOffice}
                        />
                        <ModalTidakAdaDokter
                            showModalNoDokter={this.state.showModalNoDokter}
                            cancelHandler={this.cancelHandler}
                            janjiHandler={this.janjiHandler}
                            janjiHandler2={this.janjiHandler2}
                            saveHandler={this.saveHandler}
                            List={List}
                            Model={this.state.Model}
                            Model2={this.state.Model2}
                            errors={errors}
                            idOffice={idOffice}
                        />
                        <ModalTidakAdaDokterSalahJam
                            showModalNoDokterSalahJam={this.state.showModalNoDokterSalahJam}
                            cancelHandler={this.cancelHandler}
                            janjiHandler={this.janjiHandler}
                            janjiHandler2={this.janjiHandler2}
                            saveHandler={this.saveHandler}
                            List={List}
                            Model={this.state.Model}
                            Model2={this.state.Model2}
                            errors={errors}
                            idOffice={idOffice}
                        />
                        <ModalPasien
                            showModalPasien={this.state.showModalPasien}
                            cancelHandler={this.cancelHandler}
                            List={List}
                            Model={this.state.Model}
                            Model2={this.state.Model2}
                            errors={errors}
                            janjiHandler={this.janjiHandler}
                            janjiHandler2={this.janjiHandler2}
                            idOffice={idOffice}
                        />
                    </div>
                </div>
            </div>
        )
    }
}